import { Field } from "formik";
import { Form } from "react-bootstrap";
import * as Yup from "yup";
// SubForms
import { NameAndContactSubForm, Schema as NameAndContactSchema } from '../subforms/NameAndContact';
import { EntranceDateSubForm } from '../subforms/EntranceDate';
import { OtherInformationSubForm, Schema as OtherInformationSchema } from '../subforms/OtherInformation';
import { DocumentsDiplomaSubForm, Schema as DocumentsDiplomaSchema } from '../subforms/DocumentsDiploma';

export const GundlachAzubisSchema = (settings) => (
    Yup.object()
        .concat(NameAndContactSchema(settings))
        .concat(OtherInformationSchema(settings))
        .concat(DocumentsDiplomaSchema(settings))
);

export const GundlachAzubis = (props) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Text muted>Die im Folgenden mit * markierten Felder sind Pflichtfelder.</Form.Text>
            <Field component={NameAndContactSubForm} colors={colors} settings={settings} />
            <Field component={EntranceDateSubForm} colors={colors} settings={settings} />
            <Field component={OtherInformationSubForm} colors={colors} settings={settings} />
            <Field component={DocumentsDiplomaSubForm} colors={colors} settings={settings} />
        </>
    );
}